/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ExternalFileDto } from '../../models/external-file-dto';

export interface ExternalFilesExternalFileIdGet$Json$Params {
  externalFileId: string;
}

export function externalFilesExternalFileIdGet$Json(http: HttpClient, rootUrl: string, params: ExternalFilesExternalFileIdGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ExternalFileDto>> {
  const rb = new RequestBuilder(rootUrl, externalFilesExternalFileIdGet$Json.PATH, 'get');
  if (params) {
    rb.path('externalFileId', params.externalFileId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ExternalFileDto>;
    })
  );
}

externalFilesExternalFileIdGet$Json.PATH = '/external-files/{externalFileId}';
